import {getState} from "../state/state";
import {SendToKindleDocument} from "../model/document";
import {NETWORK_STATUS_CODE, STK_DATA_TYPE, STK_FILE_TYPE} from "../../src-common/constants";
import {extractMetadataFromEpubString} from "../../src-common/utils/s2k-epub-helper";
import {createUniqId} from "../../src-common/utils/s2k-uuidHelper";

class S2KWebExtractor {
    // ################################ Initialization ################################
    constructor() {
    }

    // ################################ Delegate ################################
    /**
     * Extract content from the DOM for the current
     *
     * @param task interface to report progress and check for timeout
     * @return Extraction Result
     */
    extract(task) {
        let state = getState();
        let cloneDOM = state.stateDocument.documentElement.cloneNode(true);
        // Check if it is `send selection`
        if (state.isSelectedOnly) {
            // Get user selection
            let selectedContents = $(document.getSelection().getRangeAt(0).cloneContents()).contents() || [];
            // Empty body
            cloneDOM.querySelector('body').innerHTML = '';
            // Set user selection to body
            for (let i = 0; i < selectedContents.length; i++) {
                cloneDOM.querySelector('body').appendChild(selectedContents[i].cloneNode(true));
            }
        }
        try {
            // Create an unique ID to track the extraction action, this id will be carry to following steps, an be connected with whole STK workflow
            let extractionID = createUniqId();
            // Call WebExtraction Service to get epub from current webpage
            chrome.runtime.sendMessage({
                action: "extract-epub",
                data: {
                    url: state.stateDocument.URL,
                    content: encodeURIComponent(cloneDOM.outerHTML),
                    'extractionID': extractionID,
                }
            }, function (res) {
                // Get the result of web-extraction, the structure of res is:
                // { success: boolean, statusCode: number, statusText: string, data: { needLocalExtract: boolean, extractionResult: {statusCode: string, message:string, epubString: string}}, contentType: string | undefined}
                if (res.success) {
                    if (res.data.needLocalExtract) {
                        // If the weblab in WebService is C, will enable local extraction
                        task.backup();
                    } else if (res.data.extractionResult.statusCode === "0" ){
                        // If no need to local extraction, and the status code is success (the statusCode is string), will use remote extraction result to creat STKDocument
                        this.generateSTKDoc(res.data.extractionResult.epubString, state.stateDocument.URL, state.stateDocument.domain, extractionID).then(function (doc) {
                            if (!doc.content) {
                                // If content is undefined, means failed to retrieve info from base64 string from epub, treat it as failed
                                task.progress({
                                    success: false,
                                    statusCode: res.statusCode,
                                    statusText: res.statusText,
                                });
                            } else {
                                // If has content, treat it as success and set the result to `state`
                                state.content = doc;
                                // Callback contentJS to start next step
                                task.progress(res);
                            }
                        });
                    } else {
                        // If the statusCode from `WebExtractionService` is not success, will treat it as extraction failed
                        // Network request failed
                        task.progress({
                            success: false,
                            statusCode: res.statusCode,
                            statusText: res.statusText,
                        });
                    }
                } else {
                    // Network request failed
                    task.progress({
                        success: false,
                        statusCode: res.statusCode,
                        statusText: res.statusText,
                    });
                }
            }.bind(this));
        } catch (e) {
            task.progress({
                success: false,
                statusCode: NETWORK_STATUS_CODE.GENERAL_FAIL,
                statusText: e,
            });
        }
    }

    // ################################ Private ################################
    /**
     * Convert a given Base64 encoded string of an epub file to a STK Document
     *
     * @param {String} epubString Base64 encoded String of an epub file
     * @param {String} url Source url
     * @param {String} domain Source domain
     * @param {String} extractionID An unique id to identify the extraction flow
     * @return {Promise<SendToKindleDocument | undefined> } STK Document of current epub file
     */
    async generateSTKDoc(epubString, url, domain, extractionID) {
        // Init the STK DOC object
        let doc = new SendToKindleDocument(STK_DATA_TYPE.EPUB, undefined, STK_FILE_TYPE.EPUB);
        // Extract title, author and content from base64 string of epub file
        let metadata = await extractMetadataFromEpubString(epubString);
        doc.extractionID = extractionID;
        doc.epubString = epubString;
        doc.url = url;
        doc.source = domain;
        doc.title = metadata.title;
        doc.author = metadata.author;
        doc.content = metadata.content;
        return doc;
    }
}

export {S2KWebExtractor};